import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  List,
  Avatar,
  Typography,
  Popconfirm,
  Spin,
  Divider
} from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { OPTIONS_ROLE, OPTIONS_STATUS_SELECTION } from '../../configData'
import { userSearch } from '../../services/cmsservice'
import openNotification from '../common/Notification/openNotification '
import { hasPermission, removeVietnameseTones } from '../../config-func'
import { EditOutlined, DeleteOutlined, UserOutlined } from '@ant-design/icons'
import get from 'lodash.get'
import {
  listNote,
  noteAdd,
  noteDelete,
  noteUpdate
} from '../../services/data-customer-service'
import { current_status, status } from './configs'

dayjs.extend(utc)
dayjs.extend(timezone)
const { Text } = Typography
const { Option } = Select
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({
  data,
  form,
  fetchData,
  formSearch,
  listProject,
  mode,
  listCities,
  listDistricts,
  listTowns,
  onChangeCity,
  onChangeDistrict,
  postType,
  typeRealEstate,
  ProductType,
  onChangePostType,
  onChangeProject,
  listSelection,
  loading,
  setLoading,
  comments,
  setComments
}) => {
  const [noteForm] = Form.useForm()
  const [editingId, setEditingId] = useState(null)
  // const [loading, setLoading] = useState(true)
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data)
      if (data?.user_support) {
        form.setFieldsValue({
          user_support: data.user_support
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean)
        })
      } else {
        form.setFieldsValue({
          user_support: []
        })
      }
    }
  }, [data])

  // Danh sách note
  const getListNote = async () => {
    if (!data?.id) return
    setLoading(true)
    const params = {
      target_id: data.id,
      target_type: 'CUSTOMERDATA'
    }
    try {
      const res = await listNote(params)
      if (res?.data) {
        setComments(res?.data?.list)
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   if (data?.id) {
  //     getListNote()
  //   }
  // }, [data?.id])

  const fetchNoteAdd = async (values) => {
    if (!data?.id) return
    try {
      const body = {
        ...values,
        target_type: 'CUSTOMERDATA',
        target_id: data.id
      }
      const res = await noteAdd(body)
      if (res?.data?.note) {
        openNotification('success', res?.message || 'Thành công')
        getListNote()
        if (formSearch && fetchData) {
          const searchValues = formSearch.getFieldsValue()
          fetchData(searchValues)
        }
      }
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const fetchNoteUpdate = async (values) => {
    if (!data?.id) return
    try {
      const body = {
        ...values,
        target_type: 'CUSTOMERDATA',
        target_id: data.id
      }
      const res = await noteUpdate(body, editingId)
      if (res?.message == 'Cập nhật thành công !') {
        openNotification('success', res?.message || 'Thành công')
        getListNote()
        if (formSearch && fetchData) {
          const searchValues = formSearch.getFieldsValue()
          fetchData(searchValues)
        }
      }
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const handleNoteSubmit = (values) => {
    if (editingId !== null) {
      setEditingId(null)
      fetchNoteUpdate(values)
    } else {
      fetchNoteAdd(values)
    }
    noteForm.resetFields()
  }

  const handleNoteDelete = async (id) => {
    const body = {
      ids: [id]
    }

    try {
      const res = await noteDelete(body, id)
      if (res?.data?.id) {
        openNotification('success', res.message || 'Thành công')
        getListNote()
        if (formSearch && fetchData) {
          const searchValues = formSearch.getFieldsValue()
          fetchData(searchValues)
        }
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (err) {
      openNotification('error', 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const handleNoteEdit = (comment) => {
    setEditingId(comment.id)
    noteForm.setFieldsValue({ note: comment.note })
  }

  const user_role = localStorage.getItem('user_role')
  return (
    <>
      <Form
        form={form}
        onFinish={fetchData}
        labelAlign="left"
        layout="vertical"
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        requiredMark={customizeRequiredMark}
        disabled={mode == 'VIEW' ? true : false}
      >
        <div className={styles.formAdd}>
          <Form.Item label="" name="id" style={{ display: 'none' }}>
            <Input />
          </Form.Item>
          {/* <Form.Item
        label="Catergory"
        name="category"
        rules={[{ required: true, message: 'Vui lòng nhập category' }]}
        className={styles.formItem}
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn category"
          options={listCategory?.map((item) => ({
            label: item.title,
            value: item.value
          }))}
        />
      </Form.Item> */}
          <Form.Item label={'Dự án'} name="project" className={styles.formItem}>
            <Select
              showSearch
              onChange={onChangeProject}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              placeholder="Chọn dự án"
              disabled={user_role === 'ADMIN' ? false : true}
            >
              {listProject?.map((project) => (
                <Option key={project.value} value={project.label}>
                  {project.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* <Form.Item
          label="Loại BDS"
          name="realstate"
          rules={[{ required: true, message: 'Vui lòng nhập Loại BDS' }]}
          className={styles.formItem}
        >
          <Input placeholder="Nhập Loại BDS" />
        </Form.Item>
        <Form.Item
          label="Loại hinh BDS"
          name="type_real_estate"
          rules={[{ required: true, message: 'Vui lòng nhập Loại hình BDS' }]}
          className={styles.formItem}
        >
          <Input placeholder="Nhập Loại hình BDS" />
        </Form.Item> */}
          {/* <SelectField
            label="Loại BĐS"
            name="realstate"
            options={ProductType}
            onChange={onChangePostType}
            
          /> */}

          <Form.Item
            label="Loại BĐS"
            name="realstate"
            className={styles.formItem}
          >
            <Select
              placeholder="Chọn Loại BDS"
              showSearch={true}
              allowClear={true}
              onChange={onChangePostType}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              disabled={user_role === 'ADMIN' ? false : true}
            >
              {ProductType.map((item) => (
                <Option key={item.value} value={item.label}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Loại hình BĐS"
            name="type_real_estate"
            className={styles.formItem}
          >
            <Select
              placeholder="Chọn Loại hình BDS"
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
              disabled={user_role === 'ADMIN' ? false : true}
            >
              {typeRealEstate.map((item) => (
                <Option key={item.value} value={item.label}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {/* <SelectField
            label="Loại hình BĐS"
            name="type_real_estate"
            options={typeRealEstate}  
            disabled={user_role === 'ADMIN' ? false : true}
          /> */}
          <Form.Item
            label="Đường phố"
            name="street"
            className={styles.formItem}
          >
            <Input
              placeholder="Nhập Đường phố"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>

          <SelectField
            label="Khu vực"
            name="area"
            onChange={onChangeCity}
            options={listCities}
            disabled={user_role === 'ADMIN' ? false : true}
          />
          <SelectField
            label="Quận/Huyện"
            name="district"
            onChange={onChangeDistrict}
            options={listDistricts}
            disabled={user_role === 'ADMIN' ? false : true}
          />
          <SelectField
            label={`Phường/Xã`}
            name="tower"
            options={listTowns}
            disabled={user_role === 'ADMIN' ? false : true}
            onChange={(value) => {
              form.setFieldsValue({
                tower: value ?? ''
              })
            }}
          />

          {/* <Form.Item
          label="Khu vực"
          name="area"
          rules={[{ required: true, message: 'Vui lòng nhập Khu vực' }]}
          className={styles.formItem}
        >
          <Input placeholder="Nhập Khu vực" />
        </Form.Item>
        <Form.Item
          label="Quận/Huyện"
          name="district"
          rules={[{ required: true, message: 'Vui lòng nhập Quận/Huyện' }]}
          className={styles.formItem}
        >
          <Input placeholder="Nhập Quận/Huyện" />
        </Form.Item>
        <Form.Item
          label="Phường/Xã"
          name="tower"
          rules={[{ required: true, message: 'Vui lòng nhập Phường/Xã' }]}
          className={styles.formItem}
        >
          <Input placeholder="Nhập Phường/Xã" />
        </Form.Item> */}
          <Form.Item
            label="Loại dữ liệu"
            name="type"
            className={styles.formItem}
          >
            <Select
              placeholder="Nhập Loại dữ liệu"
              disabled={user_role === 'ADMIN' ? false : true}
            >
              <Option value="NET">NET</Option>
              <Option value="DL">DL</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Quan hệ"
            name="relationship"
            className={styles.formItem}
          >
            <Input
              placeholder="Nhập Quan hệ"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          <Form.Item
            label="Thành viên Căn Hộ"
            name="member"
            className={styles.formItem}
          >
            <Input
              placeholder="Nhập Thành viên Căn Hộ"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          <Form.Item
            label="Điện thoại"
            name="phone"
            className={styles.formItem}
          >
            <Input
              placeholder="Nhập Điện thoại"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          <Form.Item
            label="Mã căn hộ"
            name="apartment_code"
            className={styles.formItem}
          >
            <Input
              placeholder="Nhập Mã căn hộ"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          <Form.Item label="Tòa" name="building" className={styles.formItem}>
            <Input
              placeholder="Nhập Tòa"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          <Form.Item label="Tầng" name="floor" className={styles.formItem}>
            <Input
              placeholder="Nhập Tầng"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          <Form.Item label="Căn" name="room" className={styles.formItem}>
            <Input
              placeholder="Nhập Căn"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          <Form.Item label="Thông tin" name="info" className={styles.formItem}>
            <Input
              placeholder="Nhập Thông tin"
              disabled={user_role === 'ADMIN' ? false : true}
            />
          </Form.Item>
          {/* <Form.Item
            label="Nhu cầu"
            name="status"
            rules={[{ required: true, message: 'Vui lòng nhập Nhu cầu' }]}
            className={styles.formItem}
          >
            <Input placeholder="Nhập Nhu cầu" />
          </Form.Item> */}

          <SelectField
            label={`Nhu cầu`}
            name="status"
            options={status}
            onChange={(value) => {
              form.setFieldsValue({
                status: value ?? ''
              })
            }}
          />

          {/* <Form.Item
            label="Tình trạng"
            name="current_status"
            rules={[{ required: true, message: 'Vui lòng nhập Tình trạng' }]}
            className={styles.formItem}
          >
            <Input placeholder="Nhập Tình trạng" />
          </Form.Item> */}
          <SelectField
            label={`Tình trạng`}
            name="current_status"
            options={current_status}
            onChange={(value) => {
              form.setFieldsValue({
                current_status: value ?? ''
              })
            }}
          />
          <SelectField
            label={`Nội thất`}
            name="funiture"
            options={[
              { value: 'Full', label: 'Full' },
              { value: 'Cơ bản', label: 'Cơ bản' },
              { value: 'Nguyên bản', label: 'Nguyên bản' },
              { value: 'Thô', label: 'Thô' }
            ]}
            onChange={(value) => {
              form.setFieldsValue({
                funiture: value ?? ''
              })
            }}
          />
          <Form.Item label="Mã tin" name="post_id" className={styles.formItem}>
            <Input placeholder="Nhập Mã tin" />
          </Form.Item>
          {/* <Form.Item
            label="Số lần gọi"
            name="number_call"
            rules={[{ required: true, message: 'Vui lòng nhập Số lần gọi' }]}
            className={styles.formItem}
          >
            <Input placeholder="Nhập Số lần gọi" />
          </Form.Item> */}
          <Form.Item
            label="CSKH (Tên)"
            name="user_support"
            className={styles.formItem}
          >
            <Select
              mode="multiple"
              placeholder="Nhập CSKH (Tên)"
              showSearch={true}
              allowClear={true}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {listSelection?.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* <Form.Item label="Trạng thái" name="status" className={styles.formItem}>
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn trạng thái"
          options={OPTIONS_STATUS_SELECTION?.map((item) => ({
            label: item.name,
            value: item.value
          }))}
        />
      </Form.Item> */}
        </div>
      </Form>

      {/* Note Section */}
      {hasPermission('P81.4', permissions) && (
        <div style={{ maxWidth: '100%', margin: 'auto', padding: '0px 10px' }}>
          <Divider>Danh sách note</Divider>

          {/* Form nhập bình luận */}
          <Form form={noteForm} onFinish={handleNoteSubmit}>
            <Form.Item
              name="note"
              rules={[{ required: true, message: 'Nhập bình luận!' }]}
            >
              <Input.TextArea rows={2} placeholder="Viết bình luận..." />
            </Form.Item>
            <Button type="primary" htmlType="submit">
              {editingId !== null ? 'Cập nhật' : 'Thêm Note'}
            </Button>
          </Form>

          {/* Danh sách bình luận */}
          {loading ? (
            <Spin tip="Đang tải bình luận..." />
          ) : (
            <div style={{ maxHeight: 300, overflow: 'auto', marginTop: 20 }}>
              <List
                dataSource={comments}
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <EditOutlined
                        key="edit"
                        onClick={() => handleNoteEdit(item)}
                      />,
                      <Popconfirm
                        title="Xóa bình luận?"
                        onConfirm={() => handleNoteDelete(item.id)}
                      >
                        <DeleteOutlined key="delete" style={{ color: 'red' }} />
                      </Popconfirm>
                    ]}
                  >
                    <List.Item.Meta
                      avatar={<Avatar icon={<UserOutlined />} />}
                      title={
                        <Text strong>
                          {item?.user_created}
                          <Text type="secondary" style={{ marginLeft: 10 }}>
                            {item.created_at &&
                              dayjs(item.created_at.replace('Z', '')).format(
                                'HH:mm DD/MM/YYYY'
                              )}
                          </Text>
                        </Text>
                      }
                      description={item?.note}
                    />
                  </List.Item>
                )}
              />
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default FormPost
